// delete-user.js
// Handles double confirmation for user deletion (CSP-safe)
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.delete-user-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            var userId = btn.getAttribute('data-user-id');
            var modal = document.getElementById('deleteUserModal-' + userId);
            if (modal && window.$) {
                $(modal).modal('show');
            }
        });
    });
    document.querySelectorAll('.confirm-delete-user-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            var userId = btn.getAttribute('data-user-id');
            var userName = btn.getAttribute('data-user-name');
            var modal = document.getElementById('deleteUserModal-' + userId);
            if (modal && window.$) {
                $(modal).modal('hide');
            }
            setTimeout(function() {
    var form = document.querySelector('.admin-user-management__form--delete[data-user-id="' + userId + '"]');
    if (form) form.submit();
}, 300);
        });
    });
    // Cancel button handler
    document.querySelectorAll('.modal .btn-secondary').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            var modal = btn.closest('.modal');
            if (modal && window.$) {
                $(modal).modal('hide');
            }
        });
    });
});

